import type { FilterGroup, FilterState } from "@/pages/category/filters";

interface FilterBarProps {
  groups: FilterGroup[];
  state: FilterState;
  onChange: (key: keyof FilterState, value: string) => void;
  onReset: () => void;
  activeCount: number;
}

function FilterRow({
  group,
  state,
  onChange,
}: {
  group: FilterGroup;
  state: FilterState;
  onChange: (key: keyof FilterState, value: string) => void;
}) {
  const current = state[group.key];
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-3 last:border-b-0 sm:flex-row sm:items-center sm:gap-4">
      <span className="flex w-12 shrink-0 items-center gap-1 text-sm font-medium text-foreground-500">
        {group.label}
      </span>
      <div className="flex flex-wrap items-center gap-2">
        {group.key !== "sort" && (
          <button
            type="button"
            onClick={() => onChange(group.key, "all")}
            className={`whitespace-nowrap rounded-md px-2.5 py-1 text-sm transition-colors ${
              current === "all"
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
            }`}
          >
            全部
          </button>
        )}
        {group.options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(group.key, option.value)}
            className={`whitespace-nowrap rounded-md px-2.5 py-1 text-sm transition-colors ${
              current === option.value
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  groups,
  state,
  onChange,
  onReset,
  activeCount,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center justify-between">
        <span className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-900">
          <i className="ri-filter-3-line text-primary-600" />
          筛选条件
          {activeCount > 0 && (
            <span className="rounded-full bg-accent-500 px-1.5 text-[11px] font-bold text-secondary-950">
              {activeCount}
            </span>
          )}
        </span>
        <button
          type="button"
          onClick={onReset}
          disabled={activeCount === 0}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </div>
      {groups.map((group) => (
        <FilterRow
          key={group.key}
          group={group}
          state={state}
          onChange={onChange}
        />
      ))}
    </div>
  );
}